var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6814_30440)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0.597656,
    width: 39,
    height: 39,
    rx: 19.5,
    transform: "rotate(90 40 0.597656)",
    stroke: "#191919"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7148 23.2227L23.4336 19.5039C23.707 19.2305 23.707 18.8203 23.4336 18.5742L22.832 17.9453C22.5586 17.6992 22.1484 17.6992 21.9023 17.9453L19.2773 20.5977L16.625 17.9453C16.3789 17.6992 15.9688 17.6992 15.6953 17.9453L15.0664 18.5742C14.8203 18.8203 14.8203 19.2305 15.0664 19.5039L18.7852 23.2227C19.0586 23.4688 19.4688 23.4688 19.7148 23.2227Z",
    fill: "#191919"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6814_30440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(0 1 -1 0 40.5 0.0976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIcon);
export default __webpack_public_path__ + "static/media/chevron-down-icon.e7b1b8fa0ae0fd1e183eb1497af4bde7.svg";
export { ForwardRef as ReactComponent };